<div [class]="'stepper-' + variant()">
    @for (step of steps(); track $index; let i = $index, isFirst = $first) {
        @if (!isFirst) {
            <div
                class="spacer"
                [class.spacer-previous]="
                    variant() !== 'discrete' && i <= selectedIndex()
                "
            ></div>
        }
        <button
            (click)="select(step)"
            class="step"
            [class.step-previous]="
                variant() !== 'discrete' && i < selectedIndex()
            "
            [class.step-current]="selectedIndex() === i"
            type="button"
            [disabled]="step.disabled() || disableStepSelection()"
        >
            <div class="circle"></div>
            <span>{{ step.label() }}</span>
        </button>
    }
</div>
@if (selected(); as currentStep) {
    <ng-template [ngTemplateOutlet]="currentStep.content"></ng-template>
}
